import React from "react"
import { Link } from "gatsby"

import logoWhite from "./../../images/logo-white.png"
import logo from "./../../images/logo.png"
import smoothScroll from "../../utils/smooth-scroll"

class Navigation extends React.Component {
  state = {
    isActive: false,
  }

  toggleNav = () => {
    this.setState(prevState => ({
      isActive: !prevState.isActive,
    }))
  }

  navigateTo = id => {
    smoothScroll({ id: id, offset: 0 })
    this.toggleNav()
  }

  render() {
    const Logo = () => {
      if (this.props.isTransparent) {
        return <img src={logoWhite} alt="PICKS" />
      }
      return <img src={logo} alt="PICKS" />
    }
    return (
      <nav
        className={
          "navbar is-fixed-top" +
          (this.props.isTransparent ? " is-transparent" : "")
        }
      >
        <div className="container">
          <div className="navbar-brand">
            <Link className="navbar-item" to="/">
              <Logo />
            </Link>
            <span className="navbar-burger" onClick={this.toggleNav}>
              <span />
              <span />
              <span />
            </span>
          </div>
          <div
            className={
              "navbar-menu" +
              (this.state.isActive ? " is-active" : "") +
              (this.props.isTransparent ? " is-transparent" : "")
            }
          >
            <div className="navbar-end">
              <a
                className={
                  "navbar-item" +
                  (this.props.isTransparent ? " has-text-white" : "")
                }
                onClick={e => {
                  this.navigateTo("whats-picks")
                }}
              >
                Picksについて
              </a>
              <Link
                className={
                  "navbar-item" +
                  (this.props.isTransparent ? " has-text-white" : "")
                }
                to="/PicksforPartners"
              >
                飲食店オーナー様へ
              </Link>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default Navigation
